
<ng-container>
  <div #uploadArea [id]="'drag-drop-area-'+question.key" class="relative z-50"></div>

  <div class="inline-flex" *ngIf="imageUploadService.uploadedImgUrl$[question.key]|async as imgUrl">
    <img [src]="imgUrl" alt="Photo" class="image-answered">
    <button mat-icon-button [matTooltip]="'Choisir une autre image'|transloco" (click)="deleteUpload()" >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-container>


<!--<img *ngIf="surveyViewerService.isPreview()"-->
<!--     class="fake-img" [width]="'500px'" [src]="'assets/images/misc/img-up-fake.png'" alt="Image Upload">-->



